// extracted by mini-css-extract-plugin
export default {"sortable-list":"styles_sortable-list__H1251","sortableList":"styles_sortable-list__H1251"};